import React, {useContext} from "react";
import "./DeletePopup.css";
import enTranslations from "./translations/en.json";
import guTranslations from "./translations/gu.json";
import hinTranslations from "./translations/hi.json";
import mrTranslations from "./translations/mr.json";
import { LanguageContext } from "./LanguageContext";

function DeletePopup({ showDeleteAlert, setShowDeleteAlert, handleConfirmDelete }) {
  const handleConfirm = () => {
    setShowDeleteAlert(false); // Close the delete confirmation popup
    handleConfirmDelete(); // Execute the delete action
  };

  const handleCancel = () => {
    setShowDeleteAlert(false); // Close the delete confirmation popup
  };
  const { selectedLanguage } = useContext(LanguageContext);
  const translations = {
    en: enTranslations,
    gu: guTranslations,
    hin: hinTranslations,
    mr: mrTranslations,
  };

  const translatedText = (key) => translations[selectedLanguage][key] || key;


  return (
    <div className="delete-popup">
      <div className="delete-popup-content">
      <p>{translatedText("delete_message")}</p>
        <div className="button-group2">
          <button className="btn1" onClick={handleConfirm}>
            Yes
          </button>
          <button className="btn2" onClick={handleCancel}>
            No
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeletePopup;




